import { z } from "zod";
export const BOOKING_REFERENCE_CODE_ALPHABET = "0123456789ABCDEFGHJKMNPQRSTUVWXYZ";
export const BOOKING_REFERENCE_CODE_LENGTH = 6;
export const BOOKING_REFERENCE_CODE_REGEX = /^[0-9A-HJ-NP-Z]{6}$/;
export const bookingReferenceCodeSchema = z.string().regex(BOOKING_REFERENCE_CODE_REGEX);
